import React, { useCallback } from 'react';
import { IoSearchSharp } from 'react-icons/io5';
import * as styles from './DocumentSearchInput.module.css';

const DocumentSearchInput = ({ searchQuery, onSearchChange, placeholder = "Search documents..." }) => {
  const handleInputChange = useCallback((e) => {
    onSearchChange(e.target.value);
  }, [onSearchChange]);

  return (
    <div className={styles.documentSearchContainer}>
      <div className={styles.searchInputContainer}>
        <IoSearchSharp size={18} className={styles.searchIcon} />
        <input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder={placeholder}
          className={styles.searchInput}
        />
      </div>
    </div>
  );
};

export default DocumentSearchInput;